import { differenceInCalendarDays, differenceInMonths, differenceInYears } from 'date-fns';

/**
 * Compact age suffix for a past date, e.g. `~11 mo ago`, `~2 yr ago`, `~3 d ago`,
 * or `today`. Returns null for invalid or future dates so callers can omit the suffix.
 */
export function formatRelativeAge(date: Date, now: Date = new Date()): string | null {
  if (Number.isNaN(date.getTime()) || date.getTime() > now.getTime()) {
    return null;
  }

  const years = differenceInYears(now, date);
  if (years >= 1) {
    return `~${years} yr ago`;
  }

  const months = differenceInMonths(now, date);
  if (months >= 1) {
    return `~${months} mo ago`;
  }

  const days = differenceInCalendarDays(now, date);
  if (days >= 1) {
    return `~${days} d ago`;
  }

  return 'today';
}
